import * as Scrivito from "scrivito";

const LocalsConfigObj = Scrivito.provideObjClass("LocalsConfigObj", {
  attributes: {
    locals: "string",
  },
});

export default LocalsConfigObj;
